{
  "version": 1,
  "asset_id": "d5ffef8c-1ea1-4553-ada0-e3ad693a367d",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/d5ffef8c-1ea1-4553-ada0-e3ad693a367d/how-it-works-hero-640.avif",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/d5ffef8c-1ea1-4553-ada0-e3ad693a367d/how-it-works-hero-640.avif",
  "original_filename": "how-it-works-hero-640.avif",
  "size": 18998,
  "content_type": "image/avif",
  "created_at": "2026-07-22T22:51:05Z"
}
